import { React, useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import RoomIcon from "@mui/icons-material/Room";
import { Space } from "antd";
import "../../styles/EventOverview.css";

function EventOverview(props) {
  const {
    currEvent,
    currMinMembLvl,
    currMaxContacts,
    membershipLvls,
    registeredContacts,
    localDateFunc,
  } = props;
  const [allowedMembLvls, setAllowedMembLvls] = useState([]);

  useEffect(() => {
    if (currMinMembLvl != "" && currMinMembLvl != null) {
      setAllowedMembLvls(
        membershipLvls.slice(membershipLvls.indexOf(currMinMembLvl.toString()))
      );
    } else {
      setAllowedMembLvls([]);
    }
  }, [currMinMembLvl]);

  const maxContactsDisplay = allowedMembLvls.map((membershipLevel, index) => (
    <div
      className="EventOverview-ContactLists text-xl mb-8 font-brand-primary"
      key={index}>
      <p>
        Maximum number of contacts for level {membershipLevel}:
        <strong>
          {" "}
          {
            currMaxContacts[
              index + membershipLvls.length - allowedMembLvls.length
            ]
          }
        </strong>
      </p>
      <ul>
      {(membershipLevel in registeredContacts) && registeredContacts[membershipLevel].map((contact, index) => (
        <li key={index}>
          <strong>{contact.employerName}:</strong> {contact.contacts}
        </li>
      ))}
      </ul>
    </div>
  ));

  function dateFormatter(dateString) {
    const fullDate = new Date(dateString);
    if (isNaN(fullDate.getFullYear())) {
      return "Not a date";
    }
    const year = fullDate.getFullYear();
    const month = (fullDate.getMonth() + 1).toString().padStart(2, "0"); // add 1 to month because getMonth() returns 0-based index, and pad with leading zero if necessary
    const day = fullDate.getDate().toString().padStart(2, "0"); // pad with leading zero if necessary
    return `${month}/${day}/${year}`;
  }

  if (Object.keys(currEvent).length === 0 || currEvent === null) {
    return;
  }
  //console.log(registeredContacts);
  return (
    <div className="EventOverview-container rounded-xl bg-white px-6 py-16 flex flex-col overflow-y-auto">
      <div className="EventTitle-type text-6xl font-bold mb-4  font-brand-primary flex">
        {currEvent.event}
      </div>
      <div className="EventsOverview-description text-xl mb-12 wrap font-brand-primary">
        {currEvent.description}
      </div>
      <div className="EventOverview-datesContainer justify-between">
        <div className="EventOverview-date">
          <div className="EventOverview-dateLable text-2xl font-bold mb-2 font-brand-primary">
            Event Start Date:
          </div>
          <div className="EventOverview-dateText text-xl mb-3 flex font-brand-primary">
            {localDateFunc(currEvent.startDate).toLocaleDateString()}
          </div>
        </div>
        <div className="EventOverview-date">
          <div className="EventOverview-dateLabel text-2xl font-bold mb-2 font-brand-primary">
            Event End Date:
          </div>
          <div className="EventOverview-dateText text-xl mb-3 flex font-brand-primary">
            {localDateFunc(currEvent.endDate).toLocaleDateString()}
          </div>
        </div>
        <div className="EventOverview-date">
          <div className="EventOverview-dateLabel text-2xl font-bold mb-2 font-brand-primary">
            Registration Start Date:
          </div>
          <div className="EventOverview-dateText text-xl mb-3 flex font-brand-primary">
            {localDateFunc(
              currEvent.beginRegistrationDate
            ).toLocaleDateString()}
          </div>
        </div>
        <div className="EventOverview-date">
          <div className="EventOverview-dateLabel text-2xl font-bold mb-2 font-brand-primary">
            Registration End Date:
          </div>
          <div className="EventOverview-dateText text-xl mb-3 flex font-brand-primary">
            {localDateFunc(currEvent.endRegistrationDate).toLocaleDateString()}
          </div>
        </div>
      </div>
<div className="EventOverview- membLvlContainer text-2xl font- bold mb-8 font-brand- primary">
        Minimum Partnership Level Required: {currMinMembLvl}
      </div>
      <div className="EventOverview-maxContactsContainer justify-between">
        {maxContactsDisplay}
      </div>
    </div>
  );
}

EventOverview.propTypes = {
  currEvent: PropTypes.shape({
    eventId: PropTypes.number,
    event: PropTypes.string,
    description: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    beginRegistrationDate: PropTypes.string,
    endRegistrationDate: PropTypes.string,
    expireDate: PropTypes.string,
  }),
  currMinMembLvl: PropTypes.string,
  currMaxContacts: PropTypes.array,
  membershipLvls: PropTypes.array,
  registeredContacts: PropTypes.object,
  localDateFunc: PropTypes.func,
};

EventOverview.defaultProps = {
  currEvent: {},
  currMinMembLvl: "error",
  currMaxContacts: [],
  membershipLvls: [],
  registeredContacts: {},
  localDateFunc: () => {},
};

export default EventOverview;
